import { api } from 'cssapi'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import {
  fieldsColor,
  fieldsSlug,
  fieldsTitle,
  frontmatterImageSizes,
} from '../../../helpers/markdown'
import VLayout from '../../../shared/layouts/VLayout'
import TextLink from '../../../shared/links/TextLink'
import TitleSecondary from '../../../shared/titles/TitleSecondary'
import spaceChildrenH from '../../../styles/mixins/spaceChildrenH'
import spaceChildrenV from '../../../styles/mixins/spaceChildrenV'
import ArticleFooterMeta from '../../ArticleFooterMeta'
import ArticleHeadMeta from '../../ArticleHeadMeta'
import PolyImage from '../../PolyImage'

const Layout = styled.div`
  display: flex;
  ${api({
    flexDirection: [`column`, `column`, `row`],
  })};
  ${spaceChildrenH([0, 0, `1.5ru`])};
  ${spaceChildrenV([`1ru`, `1ru`, 0])};

  > * :first-child {
    ${api({
      flex: [`0 0 auto`, `0 0 auto`, `0 0 33.3%`],
    })};
  }
`

const TextLayout = styled(VLayout)`
  flex: 0 0 auto;
`

const ArticlesListItem = ({ article }) => {
  const title = fieldsTitle(article)
  const color = fieldsColor(article)
  return (
    <Layout>
      <Link to={fieldsSlug(article)} title={title}>
        <PolyImage imageSizes={frontmatterImageSizes(article)} color={color} />
      </Link>
      <TextLayout spacing="small">
        <TextLink to={fieldsSlug(article)} title={title} underlineType="left">
          <TitleSecondary>{title}</TitleSecondary>
        </TextLink>
        <ArticleHeadMeta article={article} />
        <p>{article.excerpt}</p>
        <ArticleFooterMeta article={article} />
      </TextLayout>
    </Layout>
  )
}

ArticlesListItem.propTypes = {
  article: PropTypes.object.isRequired,
}

export default ArticlesListItem



// WEBPACK FOOTER //
// ./src/components/shared/Articles/ArticleList/ArticlesListItem.jsx